import { useEffect } from 'react';
import {handlePurchaseEvent, sendAnalyticsEvents} from "../analytics";
import {buildAnalyticsCategory} from "../helpers/analyticsHelpers";

/**
 * Sends a completed purchase event
 * @param {object} order - Order object
 * @param {string} productType - Product type ('travel' | 'school' | 'sport' | 'certificate' | 'abonement')
 */
const useSendPurchaseAnalytics = (order, productType) => {
    useEffect(() => {
        if (!order?.id) return;
        const isGiftOrSubscription = ['Certificate', 'Abonement'].includes(order.category);

        const storageKey = `sent_purchase_events_${order.id}`;
        if (localStorage.getItem(storageKey)) return;

        if (isGiftOrSubscription) {
            const giftData = getPurchaseGiftData(order);
            handlePurchaseEvent({...giftData});
            sendAnalyticsEvents('purchase_main', 2);
        } else {
            const productData = getPurchaseProductData(order, productType);
            handlePurchaseEvent({...productData});
            sendAnalyticsEvents('purchase_main', 5);
        }

        localStorage.setItem(storageKey, 'true');
    }, [order, productType]);
};

const getPurchaseGiftData = (order) => {
    const category = buildAnalyticsCategory({
        ...order,
        certificate_category: order.category === 'Certificate' && order.name,
        abonement_name: order.category === 'Abonement' ? order.name : undefined,
        product_type: order.category.toLowerCase()
    });
    const mapperProduct = {
         'Certificate': 'category',
        'Abonement': 'category',
    }

    const nameProduct = order[mapperProduct[order.category]]

    return {
        name: nameProduct,
        category,
        orderId: order.id,
        depositSum: order?.depositSum || 0,
        discountedValue: order?.totalValue,
    };
}

const getPurchaseProductData = (order, productType) => {
    const product = order?.slot || order?.groupId || order?.arrival || order?.practice;
    const { name, web_url_products } = product;
    const discountedValueForPerson = parseFloat((order?.discountedValue / order?.paidForLength).toFixed(2));

    const category = buildAnalyticsCategory(order);

    return {
        id: web_url_products || '',
        name: name,
        category,
        orderId: order?.id,
        price: discountedValueForPerson || 0,
        quantity: order?.paidForLength || 1,
        revenue: order?.discountedValue,
        depositSum: order?.depositSum || 0,
        discountedValue: order?.discountedValue,
        payments: order?.payments,
        certificateSum: order?.certificate_sum
    };
};

export default useSendPurchaseAnalytics;